import { type FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import type { CreateTextTranslationWithTextSchema } from '@/routes/(app)/(playground)/(text-translation)/lib/schema';

interface InputCardProps {
  className?: string;
}

const InputCard: FC<InputCardProps> = ({ className }) => {
  const { t } = useTranslation();
  const form = useFormContext<CreateTextTranslationWithTextSchema>();
  return (
    <Card
      data-card
      className={className}>
      <CardHeader>
        <CardTitle>{t('playground.textTranslation.input.title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <FormField
          control={form.control}
          name='input'
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Textarea
                  className='min-h-[200px]'
                  {...field}
                  placeholder={t(
                    'playground.textTranslation.input.placeholder'
                  )}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </CardContent>
    </Card>
  );
};

export default InputCard;
